import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants";

import "react-toastify/dist/ReactToastify.css";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useNavigate } from "react-router-dom";
import FuseLoading from "../../../../components/FuseLoading";

const PR_Temp = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [PRTemp, setPRTemp] = useState([]);
  const [Quesdata, setQuesData] = useState([]);
  const [apiStatus, setApiStatus] = useState("");

  const columns = {
    CODE: { text: "Code", width: "50px", align: "center", visible: true },
    NAME: { text: "Name", visible: true },
    DESCRIPTION: { text: "Description", visible: true },
    CreatedByName: { text: "Created By", width: "0px", align: "left", visible: true },
  };
  const defaultColumns = {
    CODE: true,
    NAME: true,
    DESCRIPTION: true,
    CreatedByName: true,
  };

  const dispatch = useDispatch();
  useEffect(() => {
    fetchPRTemp();
    dispatch(updateNavbarHeading("PR Template Master"))
  }, [])


  const fetchPRTemp = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}appraisal-template-master`
      );
      setApiStatus(response?.status);

      if (response?.status == 200) {
        const data = response?.data?.data?.templates;


        setPRTemp(data);
        const quesdata = response?.data?.data?.questions;
        setQuesData(quesdata);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const handleView = async (id) => {

    navigate(`/appraisal-template-masters/view/${id.ID}`);
  };

  const handleAddNew = () => {
    navigate(`/appraisal-template-masters/add`);
  };

  const handleEdit = (id) => {
    navigate(`/appraisal-template-masters/edit/${id.ID}`);
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">

        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={PRTemp}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isActionRequired={true}
              isAddNewBtnRequired={true}
              showIcon1={true}
              showIcon2={false}
              showIcon3={true}
              showIcon4={false}
              showIcon5={false}
              handleIcon3={handleView}
              handleAddNew={handleAddNew}
              handleIcon1={handleEdit}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon1Text: " Edit",
                Icon2: <i class="bi bi-trash-fill icons"></i>,
                Icon3: <i class="bi bi-eye-fill icons"></i>,
                Icon3Text: "View",
                Icon4: <i class="bi bi-plus-square icons"></i>,
                Icon4Text: " Add Sub-Contractor",
              }}
            />
          </div>
        </div>

      </div>
    </>
  );
};

export default PR_Temp;
